<template>
  <div>
    <b-card class="">
      <!-- Search Patient Name -->
      <div class="h-50">
        <div>
          <h2>{{ $t("reception.Patient Surgery") }}</h2>
        </div>
        <div class="d-flex justify-content-between">
          <div class="w-50">
            <div v-if="patientSurgery">
              <div class="d-flex flex-wrap">
                <div class="mx-1">
                  <span>{{ $t("common.date") }}</span> :

                  <span>{{ patientSurgery.surgery_date_time }}</span>
                </div>
                <div class="mx-1">
                  <span>{{ $t("common.price") }}</span> :
                  <span>{{ patientSurgery.price }}</span>
                </div>
                <div class="mx-1">
                  <span>{{ $t("surgery.haveSubSurgery") }}</span> :
                  <span>{{
                    patientSurgery.sub_surgeries.length > 0 ? "Yes" : "No"
                  }}</span>
                </div>
              </div>
            </div>
            <div
              v-else
              class="w-100 d-flex align-items-center flex-column h-75 d-flex justify-content-center align-items-center"
            >
              <h4>No Patient Surgery Available.</h4>
              <div v-if="!doctors.length > 0">
                the Patient Dosen't have any Doctors.
              </div>
            </div>
          </div>
          <div class="w-25">
            <b-card>
              <!---->
              <b-button
                v-if="!patientSurgery && !isHistory && doctors.length > 0"
                @click="navigateWithDoctors"
                variant="info"
                class="p-1 mb-1"
                block
              >
                {{ $t("reception.Create Patient Surgery") }}
              </b-button>
            </b-card>
            <b-card>
              <b-button
                v-if="patientSurgery"
                @click="
                  $router.push({
                    name: 'patient-surgery-info',
                    params: { id: patientSurgery.id },
                  })
                "
                variant="warning"
                class="p-1 mb-1"
                block
              >
                {{ $t("common.preview") }}
              </b-button>
            </b-card>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import router from "@/router";

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    Datepicker,
    DeleteModal,
    ActionsButtons,
  },

  props: ["patientCardId", "patientSurgery", "doctors", "isHistory"],

  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      surgeryId: null,
      surgery: {},
      doctorSurgery: null,
      dataCount: 0,
      data: [],

      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },

  methods: {
    navigateWithDoctors() {
      // Update Vuex store with doctors
      this.$store.dispatch("updateDoctors", this.doctors);

      // Navigate to the new route
      this.$router.push({
        name: "add-patient-surgery",
        params: {
          id: this.patientCardId,
        },
        query: {
          patientId: this.$route.params.id,
        },
      });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
